package com.zaurh.portfolio.data.request

import kotlinx.serialization.Serializable

@Serializable
data class ContactRequest(
    val access_key: String,
    val name: String,
    val email: String,
    val subject: String,
    val message: String
)